module.exports = __webpack_public_path__ + "img/youthtop.0da5a803.jpg";